'use client';

import { setUser } from '@/app/lib/store/user-slice';
import { useAppDispatch } from '@/app/lib/store/hooks';
import { useState } from 'react';
import MockSignInDialogButton from './mock-sign-in-dialog-button';

interface MockSignInDialogButtonContainerProps {
  onClose: () => void;
}

export default function MockSignInDialogButtonContainer({
  onClose
}: MockSignInDialogButtonContainerProps) {
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(false);

  const handleSignIn = async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/auth/mock-vk/callback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({})
      });

      if (response.ok) {
        const data = await response.json();
        onClose();
        dispatch(setUser(data.user));
      } else {
        const { error } = await response.json();
        console.error(error);
      }
      setLoading(false);
    } catch (error) {
      throw new Error(`Не удалось авторизовать пользователя, ${error}`);
    }
  };

  return (
    <MockSignInDialogButton
      loading={loading}
      onSignIn={handleSignIn}
    />
  );
}
